/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface HeadcountOverviewDetailedTeamMembersUpdateTeamMemberAvailabilityModel {
  id?: string | null;
  startDate: string;
  endDate?: string | null;
  title?: HeadcountOverviewDetailedTeamMembersUpdateTeamMemberAvailabilityModelTitleEnum | null;
  description?: string | null;
}
export enum HeadcountOverviewDetailedTeamMembersUpdateTeamMemberAvailabilityModelTitleEnum {
  Terminated = 'Terminated',
  Dormant = 'Dormant',
  Active = 'Active',
  Other = 'Other'
}
